import { LOCALE_ID, NgModule } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { BrowserModule } from '@angular/platform-browser';

// Deutsche Formate für Datums-/Zahlen-Pipes (z.B. Wochentagsnamen "Mittwoch" statt "Wednesday").
registerLocaleData(localeDe);
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NavbarService } from './nav-menu/navmenue.service';
import { ElementReturnService } from '../Services/element-return.service';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { LayoutModule } from '@angular/cdk/layout';
import { MatChipsModule } from '@angular/material/chips';
import { MatCheckboxModule } from '@angular/material/checkbox'; // Make sure this is imported
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBarModule } from '@angular/material/snack-bar';


import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomPaginatorIntl } from './CustomClasses/custom-paginator-intl/custom-paginator-intl.service';

// Meine Komponenten
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { ElementeListeComponent} from './element-liste/elemente-liste/elemente-liste.component';
import { UserListComponent } from './user-list/user-list.component';
import { UserFormComponent } from './user-form/user-form.component';
import { LoginComponent } from './user-login/user-login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { AppRoutingModule } from './app-routing.module';
import { AuthGuard } from '../api-authorization/auth.guard';
import { AdminGuard } from '../api-authorization/AdminGuard';
import { AuthInterceptor } from '../api-authorization/auth.interceptor';
import { UserDashboardComponent } from './user-dashboard/user-dashboard.component';
import { ResetPasswordDialogComponent } from './user-form/reset-password-dialog/reset-password-dialog.component';
import { ElementDialogComponent } from './element-liste/element-dialog/element-dialog.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { UserRegisterComponent } from './user-register/user-register.component';
import { DeviceListComponent } from './device-list/device-list.component';
import { ElementWithdrawalDialogComponent } from './elementwithdraw/element-withdrawal-dialog/element-withdrawal-dialog.component';
import { UserWithdrawalHistoryComponent } from './elementwithdraw/user-withdrawal-history/user-withdrawal-history.component';
import { ElementWithdrawalHistoryComponent } from './elementwithdraw/element-withdrawal-history/element-withdrawal-history.component';
import { ConfirmDialogComponent } from './shared/confirm-dialog/confirm-dialog.component';
import { ConfirmDeleteDialogComponent } from './user-list/confirm-delete-dialog/confirm-delete-dialog.component';
// Wartung Module
import { WartungDashboardComponent } from './Wartung/wartung-dashboard/wartung-dashboard.component';
import { CustomerListComponent } from './Wartung/customer-list/customer-list.component';
import { CustomerDetailComponent } from './Wartung/customer-detail/customer-detail.component';
import { CustomerFormComponent } from './Wartung/customer-form/customer-form.component';
import { EquipmentFormComponent } from './Wartung/equipment-form/equipment-form.component';
import { MaintenanceFormComponent } from './Wartung/maintenance-form/maintenance-form.component';
import { MaintenanceDetailComponent } from './Wartung/maintenance-detail/maintenance-detail.component';
import { ServiceReportDialogComponent } from './Wartung/shared/service-report-dialog/service-report-dialog.component';
import { ServiceCallFormComponent } from './Wartung/service-call-form/service-call-form.component';
import { CommercialBillingComponent } from './Wartung/commercial-billing/commercial-billing.component';
// SBOM Module
import { SbomListComponent } from './Sbom/sbom-list/sbom-list.component';
import { SbomDetailComponent } from './Sbom/sbom-detail/sbom-detail.component';
import { SbomProjectFormComponent } from './Sbom/sbom-project-form/sbom-project-form.component';
import { SbomComponentFormComponent } from './Sbom/sbom-component-form/sbom-component-form.component';
import { SecurityAssessmentComponent } from './Sbom/security-assessment/security-assessment.component';
import { BerichteComponent } from './berichte/berichte.component';
// Ressourcenplanung
import { ResourceTimelineComponent } from './Ressourcenplanung/resource-timeline/resource-timeline.component';
import { AssignmentDialogComponent } from './Ressourcenplanung/assignment-dialog/assignment-dialog.component';
import { PlanningAdminDialogComponent } from './Ressourcenplanung/planning-admin-dialog/planning-admin-dialog.component';
import { AvailabilityDialogComponent } from './Ressourcenplanung/availability-dialog/availability-dialog.component';
// Stammkunden
import { StammkundenListComponent } from './Stammkunden/stammkunden-list/stammkunden-list.component';
import { StammkundeDetailComponent } from './Stammkunden/stammkunde-detail/stammkunde-detail.component';
import { AuftragFormComponent } from './Stammkunden/auftrag-form/auftrag-form.component';
import { AuftragDetailComponent } from './Stammkunden/auftrag-detail/auftrag-detail.component';
import { EinsatzFormComponent } from './Stammkunden/einsatz-form/einsatz-form.component';
import { EinsatzPlanungComponent } from './Stammkunden/einsatz-planung/einsatz-planung.component';
import { TeamFormComponent } from './Stammkunden/team-form/team-form.component';
import { WorkerFormComponent } from './Stammkunden/worker-form/worker-form.component';
import { LagerLinkComponent } from './Stammkunden/lager-link/lager-link.component';
import { MeineEinsaetzeComponent } from './Stammkunden/meine-einsaetze/meine-einsaetze.component';
import { BauleiterUebersichtComponent } from './Stammkunden/bauleiter-uebersicht/bauleiter-uebersicht.component';
import { ZeitEintragFormComponent } from './Stammkunden/zeit-eintrag-form/zeit-eintrag-form.component';
import { StundenErfassungComponent } from './Stammkunden/stunden-erfassung/stunden-erfassung.component';
import { MaterialErfassungComponent } from './Stammkunden/material-erfassung/material-erfassung.component';
import { SpontanEinsatzFormComponent } from './Stammkunden/spontan-einsatz-form/spontan-einsatz-form.component';

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    CounterComponent,
    FetchDataComponent,
    ElementeListeComponent,
    UserListComponent,
    UserFormComponent,
    LoginComponent,
    ForgotPasswordComponent,
    UserDashboardComponent,
    ResetPasswordDialogComponent,
    ElementDialogComponent,
    ChangePasswordComponent,
    UserRegisterComponent,
    DeviceListComponent,
    ElementWithdrawalDialogComponent,
    UserWithdrawalHistoryComponent,
    ElementWithdrawalHistoryComponent,
    ConfirmDialogComponent,
    ConfirmDeleteDialogComponent,
    // Wartung
    WartungDashboardComponent,
    CustomerListComponent,
    CustomerDetailComponent,
    CustomerFormComponent,
    EquipmentFormComponent,
    MaintenanceFormComponent,
    MaintenanceDetailComponent,
    ServiceReportDialogComponent,
    ServiceCallFormComponent,
    CommercialBillingComponent,
    // SBOM
    SbomListComponent,
    SbomDetailComponent,
    SbomProjectFormComponent,
    SbomComponentFormComponent,
    SecurityAssessmentComponent,
    BerichteComponent,
    // Ressourcenplanung
    ResourceTimelineComponent,
    AssignmentDialogComponent,
    PlanningAdminDialogComponent,
    AvailabilityDialogComponent,
    // Stammkunden
    StammkundenListComponent,
    StammkundeDetailComponent,
    AuftragFormComponent,
    AuftragDetailComponent,
    EinsatzFormComponent,
    EinsatzPlanungComponent,
    TeamFormComponent,
    WorkerFormComponent,
    LagerLinkComponent,
    MeineEinsaetzeComponent,
    BauleiterUebersichtComponent,
    ZeitEintragFormComponent,
    StundenErfassungComponent,
    MaterialErfassungComponent,
    SpontanEinsatzFormComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    LayoutModule,

    MatCheckboxModule,
    MatSlideToggleModule,
    MatToolbarModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTableModule,
    MatDialogModule,
    MatIconModule,
    MatCardModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatGridListModule,
    MatMenuModule,
    MatProgressBarModule,
    MatListModule,
    MatPaginatorModule,
    MatTabsModule,
    MatSidenavModule,
    AppRoutingModule,
    MatAutocompleteModule,
    MatSortModule,
    MatChipsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonToggleModule,
    MatExpansionModule,
    MatSnackBarModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl },
    { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
    { provide: LOCALE_ID, useValue: 'de' },
    AuthGuard,
    AdminGuard,
    NavbarService,
    ElementReturnService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
